import { z } from "zod";

export const captionBottomInsetPercentSchema = z
  .number()
  .finite()
  .min(0)
  .max(50);

export function downloadedCaptionInsetPercent(
  item:
    | {
        fileUploadedAt?: string | null;
        captionBottomInsetPercent?: number;
        download?: {
          fileUploadedAt?: string | null;
          captionBottomInsetPercent?: number;
        } | null;
      }
    | undefined,
): number {
  const downloadedFile = item?.download?.fileUploadedAt;

  if (downloadedFile == null) {
    return 0;
  }

  const value =
    item?.fileUploadedAt === downloadedFile
      ? (item.captionBottomInsetPercent ??
        item.download?.captionBottomInsetPercent ??
        0)
      : (item?.download?.captionBottomInsetPercent ?? 0);
  return captionBottomInsetPercentSchema.safeParse(value).data ?? 0;
}
